import { Component, OnInit, Input, Output, Inject, EventEmitter } from '@angular/core';
import { Router } from "@angular/router";
import { environment } from '../../../environments/environment';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { CurrentUser } from '../../security/current-user.model';
import { CurrentUserService } from "../../security/current-user.service";
import { FacetedSearchAppService } from '../webapi/faceted-search-app.service';

@Component({
  selector: 'confirmation-dialog',
  templateUrl: 'confirmation-dialog.component.html',
  styleUrls: ['confirmation-dialog.component.css']
})
export class ConfirmationDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.title = data.title ? data.title : "";
    this.text = data.text ? data.text : "";
  }

  dialogFormGroup: any;

  public title: string = "";
  public text: string = "";
  public okText: string = "OK";
  public cancelText: string = "Cancel";

  public presetName: string;

  ok() {
    this.dialogRef.close(1);
  }

  cancel() {
    this.dialogRef.close(0);
  }

  ngOnInit(): void {
    this.dialogRef.disableClose = true;
  }

}



// WEBPACK FOOTER //
// ./src/app/fsapplication/confirmation-dialog/confirmation-dialog.component.ts